import { STORAGE_KEY_CURRENT_USER, STORAGE_KEY_ID_PERFIL } from '../storageCore/constStorageKeys';
import storageX from '../storageCore/storageX';

export const USER_DATA = function (){
    return { 
      profileId: storageX.whereKeyIs(STORAGE_KEY_ID_PERFIL).get(),
      userId: storageX.whereKeyIs(STORAGE_KEY_CURRENT_USER).get()?.id
    }
  }